__turbopack_context__.v({
  "component": "HeroAddressCheck5G-module__49icKq__component",
  "component__ctaContainer": "HeroAddressCheck5G-module__49icKq__component__ctaContainer",
  "component__layout": "HeroAddressCheck5G-module__49icKq__component__layout",
  "component__mobileBackground": "HeroAddressCheck5G-module__49icKq__component__mobileBackground",
  "component__wrapper": "HeroAddressCheck5G-module__49icKq__component__wrapper",
  "hide-for-large": "HeroAddressCheck5G-module__49icKq__hide-for-large",
  "hide-for-large-only": "HeroAddressCheck5G-module__49icKq__hide-for-large-only",
  "hide-for-medium": "HeroAddressCheck5G-module__49icKq__hide-for-medium",
  "hide-for-medium-only": "HeroAddressCheck5G-module__49icKq__hide-for-medium-only",
  "hide-for-small-only": "HeroAddressCheck5G-module__49icKq__hide-for-small-only",
  "show-for-large": "HeroAddressCheck5G-module__49icKq__show-for-large",
  "show-for-large-only": "HeroAddressCheck5G-module__49icKq__show-for-large-only",
  "show-for-medium": "HeroAddressCheck5G-module__49icKq__show-for-medium",
  "show-for-medium-only": "HeroAddressCheck5G-module__49icKq__show-for-medium-only",
  "show-for-small-only": "HeroAddressCheck5G-module__49icKq__show-for-small-only",
  "u-color-black": "HeroAddressCheck5G-module__49icKq__u-color-black",
  "u-color-blue": "HeroAddressCheck5G-module__49icKq__u-color-blue",
  "u-color-midnight": "HeroAddressCheck5G-module__49icKq__u-color-midnight",
  "u-color-primary-dark": "HeroAddressCheck5G-module__49icKq__u-color-primary-dark",
  "u-color-red": "HeroAddressCheck5G-module__49icKq__u-color-red",
  "u-color-white": "HeroAddressCheck5G-module__49icKq__u-color-white",
  "u-theme-black": "HeroAddressCheck5G-module__49icKq__u-theme-black",
  "u-theme-blue": "HeroAddressCheck5G-module__49icKq__u-theme-blue",
  "u-theme-dark": "HeroAddressCheck5G-module__49icKq__u-theme-dark",
  "u-theme-light": "HeroAddressCheck5G-module__49icKq__u-theme-light",
  "u-theme-red": "HeroAddressCheck5G-module__49icKq__u-theme-red",
  "u-theme-white": "HeroAddressCheck5G-module__49icKq__u-theme-white",
});
